<template>
  <div class="template-detail-body">
    <div class="ccui-app-container-detail2">
      <div ref="detailBody" class="ccui-app-container-detail-body">
        <!-- 未开始 -->
        <div style="margin-bottom:10px" v-if="flag === '0' || flag === '1'">
          <!-- 投标承诺响应环节未开始 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.yet4')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <!-- 已开始 -->
        <div v-if="flag == 2 || flag == 3">
          <!-- 投标承诺响应 -->
          <el-group-title :title="$t('page.content.response')">
            <template slot="groupTitle">
              <div class="tip">
                <p class="tip-title">
                  <!-- 标题 -->
                  {{ $t("page.content.Title") }}：{{
                    sscSupResponseBO.noticeTitle
                  }}
                </p>
                <!-- 内容 -->
                <p>
                  {{ $t("page.content.Content") }}：<span
                    v-html="sscSupResponseBO.textInfo"
                  ></span>
                </p>
              </div>
            </template>
          </el-group-title>
          <!-- 附件列表 -->
          <detailBaseTable
            :title="$t('page.content.Attachments')"
            :table-head="tableChangeHistoryHead"
            :table-data="tableChangeHistoryData"
          >
            <!-- 附件大小 -->
            <template :slot="$t('page.content.Size')" slot-scope="{ row }">
              <span>{{ row.fileSize }}kb</span>
            </template>
            <!-- 下载 -->
            <template
              :slot="$t('page.content.operation')"
              slot-scope="{ row, $index }"
            >
              <el-button
                size="mini"
                type="text"
                @click="downloadUrlFile(row, $index)"
              >
                <!-- 下载 -->
                {{ $t("page.content.Download") }}
              </el-button>
              <!-- 预览 -->
              <el-button size="mini" type="text" @click="preview(row)">
                {{ $t("page.content.Yulan") }}
              </el-button>
            </template>
          </detailBaseTable>
          <!-- 承诺文件列表 -->
          <el-group-title :title="$t('page.content.Attachment')">
            <template slot="groupTitle">
              <attachmentUpload
                ref="bidResponseTable"
                :fileData="tableDownloadData"
                :type="flag == 2 && tableDownload.length == 0 ? 1 : 2"
              ></attachmentUpload>
            </template>
          </el-group-title>
        </div>
      </div>
    </div>
    <!--底部功能按钮-->
    <div class="operate" :style="{ width: width }" v-if="flag == 2">
      <!-- 提交 -->
      <el-button
        type="text"
        icon="icon-ccui-agree"
        :disabled="isShowBtn"
        @click="submit"
        >{{ $t("page.content.Submit1") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import { getPreviewUrl } from "@/basa/utils";
import {
  qryBidResponseDetailSub,
  dealBidResponseSubmitSub
} from "@/app/myProjects/api/myProjectsEl.js";
import { addUrlPerFix } from "@/basa/utils";
import attachmentUpload from "@/basa/components/common/attachmentUploadSub.vue";
export default {
  components: {
    attachmentUpload
  },
  activated() {},
  data() {
    return {
      width: "1000px",
      flagCom: 1, //是否竞争性
      flag: "", //0 编辑中 1待发布 2 公式中 3公示结束
      agentId: "",
      supInfo: {},
      schemeId: "",
      sscSupResponseBO: {}, //供应商响应信息
      // 附件列表
      tableChangeHistoryHead: [
        { label: this.$t("page.content.name"), prop: "fileName" }, //附件名称
        { label: this.$t("page.content.Description"), prop: "fileSumm" }, //附件说明
        {
          label: this.$t("page.content.Size"),
          prop: "fileSize",
          slot: this.$t("page.content.Size")
        }, //附件大小
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          slot: this.$t("page.content.operation"),
          width: "100"
        } //下载
      ],
      tableChangeHistoryData: [],
      tableDownloadData: [],
      tableDownload: [],
      supCode: sessionStorage.getItem("subcontractorCode"),
      isShowBtn: true
    };
  },
  created() {},
  mounted() {
    this.width = this.$refs["detailBody"].scrollWidth + "px";
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.getBidResponseDetail(1);
  },
  methods: {
    getBidResponseDetail(type) {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { supProcessId: this.$route_query.supProcessId },
        { agentId: this.agentId }
      );
      qryBidResponseDetailSub(param).then(res => {
        if (res) {
          if (type == 1) {
            this.isShowBtn = !!res.data.data.responseTime;
          } else {
            this.isShowBtn = true;
          }

          if (res.data.data.sscSupResponseBO) {
            this.sscSupResponseBO = res.data.data.sscSupResponseBO;
            this.flag = this.sscSupResponseBO.noticeStatus;
          } else {
            //防止后端没返数据时显示出错
            this.flag = "0";
          }
          this.tableChangeHistoryData = res.data.data.sscPurchaseFileBOS;
          this.tableDownloadData = JSON.parse(
            JSON.stringify(res.data.data.sscSupFileBOS)
          );
          this.tableDownload = JSON.parse(
            JSON.stringify(res.data.data.sscSupFileBOS)
          );
          let obj = {
            leftTime: "",
            cutTime: "",
            leftName: this.$t("page.content.Remaining1"), //承诺响应剩余时间
            cutName: this.$t("page.content.Deadline1"), //承诺响应截止时间
            isShowexeTime: true,
            isShowTag: false,
            isShowLeftTime: false,
            isShowCouTime: false
          };
          if (this.flag == 2 || this.flag == 3) {
            obj.leftTime = this.sscSupResponseBO.noticeEndTime;
            obj.cutTime = this.sscSupResponseBO.noticeEndTime;
            obj.isShowLeftTime = true;
            obj.isShowCouTime = true;
          }
          this.$store.commit("edit", obj);
        }
      });
    },
    submit() {
      let tableUpData = this.$refs.bidResponseTable.fileData;
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { supProcessId: this.$route_query.supProcessId }, //不知道哪里能拿到
        { agentId: this.agentId },
        { FileInfoBOs: tableUpData }
      );
      // 您是否确认提交
      this.$confirm(
        this.$t("page.content.suresubmit"),
        this.$t("page.content.Submit1"),
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("page.content.sure1"),
          cancelButtonText: this.$t("page.content.cancel"),
          customClass: "ccui-message-box-custom"
        }
      ).then(() => {
        param.isShowLoading = true;
        dealBidResponseSubmitSub(param).then(res => {
          if (res) {
            this.getBidResponseDetail(2);
            this.$message({
              message: this.$t("page.content.Submitted3"),
              type: "success",
              duration: 3000,
              offset: document.documentElement.clientHeight / 2 - 21
            });
          }
        });
      });
    },
    downloadUrlFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    handleBack() {
      this.$router.back();
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>
<style lang="scss" scoped>
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}
.tip {
  padding-left: 20px;
  color: #4a4a4a;
  font-size: 13px;
  .tip-title {
    margin-bottom: 20px;
  }
}
.sub-contractor-detail-form-item {
  margin: 30px 20px;
}
.ccui-group-wrapper {
  /deep/ .el-table .el-table__body .cell {
    height: 36px;
    line-height: 36px;
  }
}
.sub-contractor-detail-body {
  color: #4a4a4a;
}
.sub-contractor-detail {
  margin: 15px 0 80px;
}
.breadName {
  margin-left: 10px;
}
.col-bottom {
  margin-bottom: 20px;
}
.operate {
  position: fixed;
  width: calc(100% - 270px);
  bottom: 20px;
  z-index: 999;
  height: 40px;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
</style>
